<template>
  <ValidationProvider :name="name" :rules="rules" v-slot="{ errors }" class="field__item">
    <div class="field__item--label">
    </div>
    <div :class="{'input__group--red': errors.length > 0}"
         class="field__item--select" @click="focusThis()">
      <span ref="label" class="dynamic-label" :class="{ 'focused' : shouldHaveFocused}">{{ label }}</span>
      <span class="icon--caret"></span>
      <select @focus="focused = true" @blur="focused = false" @click="openDropdown()" :id="name" :name="name" @change="change"
              :value="value" ref="select">
        <option value=""></option>
        <option v-for="(item, index) in items" :value="item[valueKey]" :selected="value === item[valueKey]"
                :key="index"> {{
          item[labelKey] }}
        </option>
      </select>
    </div>
    <span :class="{'form__notice--active': errors.length > 0}"
          class="form__notice text--red">{{ errors[0] }}</span>
  </ValidationProvider>
</template>

<script>
export default {
  name: 'FieldSelect',
  props: {
    valueKey: {
      type: String,
      default: 'id'
    },
    labelKey: {
      type: String,
      default: 'name'
    },
    label: String,
    name: String,
    rules: String,
    value: [String, Number],
    classes: {},
    required: {
      type: Boolean,
      default: true
    },
    items: Array,
    placeholder: String
  },
  data () {
    return {
      focused: false
    }
  },
  computed: {
    shouldHaveFocused () {
      if (this.focused) {
        return true
      }

      return this.value === null ? false : !!(typeof this.value !== 'undefined' && this.value !== '')
    }
  },
  methods: {
    selectedOption (option) {
      if (this.value) {
        return option[this.valueKey] === this.value
      }
      return false
    },
    change (event) {
      this.$emit('input', event.target.value)
    },
    focusThis: function (event) {
      this.$refs.select.focus()
    },
    openDropdown () {
      setTimeout(function () {
        var evt = new KeyboardEvent('keydown', { keyCode: 32 })
        document.dispatchEvent(evt)
      }, 1000)
    }
  }
}
</script>
